import { string } from "yup";
import axios from "axios";
import Utilisateur from "../Models/Utilisateur";
import { apiEndpoints } from "../config";
import { Crypter } from "../Functions/Security/Crypter";
import Hash from "../Functions/Security/Hash";
import Agence from "../Models/Agence";
import * as React from "react";
import Datas from "../Data/Data.json";
//import { Crypter } from '../Functions/Security/Crypter';
import { useAuthHeader, useSignOut } from "../Services/Auth/sessionAuth";
import { useNavigate } from "react-router-dom";
//import SweetAlert from '../Functions/Traitement/SweetAlert';
import SweetAlert from "sweetalert2";
import { useState } from "react";
//const authHeader = useAuthHeader()
import Data from "../Data/Data.json";
import ParamsPicklist from "../Types/ParamsPicklist";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
//import "jspdf-autotable"
import autoTable from "jspdf-autotable"; // ✅ important
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  WidthType,
  TextRun,
} from "docx";
//import { saveAs } from "file-saver";

export function getFirstPart(str: string, separator: string): string {
  if (!str || !separator) return "";
  const parts = str.split(separator);
  return parts.length > 0 ? parts[0].trim() : "";
}

export function getLastPart(str: string, separator: string): string {
  if (!str || !separator) return "";
  const index = str.indexOf(separator);

  if (index === -1) {
    return ""; // Si le séparateur n'est pas trouvé
  }

  const first = str.substring(0, index).trim();
  const rest = str.substring(index + separator.length).trim();

  return rest;
}

export async function getField(
  nomTable: string,
  idColonne: string,
  libelleColonne: string,
  libelleCodAge: string,
  valeurCodAge: string,
  critere: string,
) {
  try {
    // const [libelle, setLibelle] = useState("")

    const token = localStorage.getItem("token"); // ou selon ton système
    const response = await axios.post(
      apiEndpoints.getfield,
      {
        NomTable: nomTable,
        IdColonne: idColonne,
        LibelleColonne: libelleColonne,
        LibelleCodBur: libelleCodAge,
        ValeurCodBur: valeurCodAge,
        CritereRecherche: critere,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    // data = response.json()
    // setLibelle(response.data)
    return response.data[0]?.["Libelle"] ?? "";
  } catch (error: any) {
    console.error(
      "Erreur de recherche :",
      error.response?.data || error.message,
    );
  }
}

export function normalizeKeysToUppercase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(normalizeKeysToUppercase); // Pour un tableau d’objets
  } else if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.toUpperCase(),
        typeof value === "object" && value !== null
          ? normalizeKeysToUppercase(value)
          : value,
      ]),
    );
  }
  return obj; // si ce n’est ni un tableau ni un objet, on retourne la valeur
}

export async function fetchDataTable2(
  stringApi: string,
  params: any,
  authHeader: string,
): Promise<any> {
  // USER TOKEN

  // const token = localStorage.getItem("token");
  //const authHeader = useAuthHeader();
  // const normalizedData = normalizeKeysToUppercase(rawData);
  console.log(params);
  try {
    const response = await axios.get(stringApi, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${authHeader}`,
        CypherSearch: Crypter.encrypt(JSON.stringify(params)),
      },
      //  params:Crypter.encrypt(JSON.stringify(params)),
    });
    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
    // console.log(res)
    if (res.StatutCode == 200) {
      let datas = res.Result.Table;

      if (datas.length !== 0) {
        //console.log("aucun élément ");
        // console.log(datas);
        return datas;
      }
    }
  } catch (error) {
    console.error("Erreur de chargement :", error);
    return null;
  }
}

export async function fetchDataTable(stringApi: string): Promise<any> {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(stringApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    //  console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Erreur de chargement :", error);
    return null;
  }
}

export function toUpperFields(obj: any, fields: string[]): any {
  const result = { ...obj };
  for (const field of fields) {
    if (typeof result[field] === "string") {
      result[field] = result[field].toUpperCase().trim();
    }
  }
  return result;
}

export const formatDate = (date?: string | Date | null): string => {
  const d = date && date !== "" ? new Date(date) : new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Définition d'un type pour une seule dénomination
export type Denomination = {
  value: number;
  label: string;
};

// Définition des codes de devise connus
export type CurrencyCode = "XAF" | "USD" | "EUR";

// Dénominations pour XAF
const denominationsXAF: Denomination[] = [
  { value: 10000, label: "Billet 10 000 XAF" },
  { value: 5000, label: "Billet 5 000 XAF" },
  { value: 2000, label: "Billet 2 000 XAF" },
  { value: 1000, label: "Billet 1 000 XAF" },
  { value: 500, label: "Billet 500 XAF" },
  { value: 500, label: "Pièce 500 XAF" },
  { value: 200, label: "Pièce 200 XAF" },
  { value: 100, label: "Pièce 100 XAF" },
  { value: 50, label: "Pièce 50 XAF" },
  { value: 25, label: "Pièce 25 XAF" },
  { value: 10, label: "Pièce 10 XAF" },
  { value: 5, label: "Pièce 5 XAF" },
  { value: 2, label: "Pièce 2 XAF" },
  { value: 1, label: "Pièce 1 XAF" },
];

// Dénominations pour USD (exemple simplifié)
const denominationsUSD: Denomination[] = [
  { value: 100, label: "Billet 100 USD" },
  { value: 50, label: "Billet 50 USD" },
  { value: 20, label: "Billet 20 USD" },
  { value: 10, label: "Billet 10 USD" },
  { value: 5, label: "Billet 5 USD" },
  { value: 1, label: "Billet 1 USD" },
  { value: 0.25, label: "Pièce 25 Cents (Quarter)" },
  { value: 0.1, label: "Pièce 10 Cents (Dime)" },
  { value: 0.05, label: "Pièce 5 Cents (Nickel)" },
  { value: 0.01, label: "Pièce 1 Cent (Penny)" },
];

// Dénominations pour EUR (exemple simplifié)
const denominationsEUR: Denomination[] = [
  { value: 500, label: "Billet 500 EUR" },
  { value: 200, label: "Billet 200 EUR" },
  { value: 100, label: "Billet 100 EUR" },
  { value: 50, label: "Billet 50 EUR" },
  { value: 20, label: "Billet 20 EUR" },
  { value: 10, label: "Billet 10 EUR" },
  { value: 5, label: "Billet 5 EUR" },
  { value: 2, label: "Pièce 2 EUR" },
  { value: 1, label: "Pièce 1 EUR" },
  { value: 0.5, label: "Pièce 50 Centimes" },
  { value: 0.2, label: "Pièce 20 Centimes" },
  { value: 0.1, label: "Pièce 10 Centimes" },
  { value: 0.05, label: "Pièce 5 Centimes" },
  { value: 0.02, label: "Pièce 2 Centimes" },
  { value: 0.01, label: "Pièce 1 Centime" },
];

// Mappage des dénominations par devise
// La clé 'key in CurrencyCode' garantit que seules les clés 'XAF' | 'USD' | 'EUR' sont autorisées
export const allDenominations: { [key in CurrencyCode]: Denomination[] } = {
  XAF: denominationsXAF,
  USD: denominationsUSD,
  EUR: denominationsEUR,
};

// Types pour les devises et caisses (si vous les utilisez ailleurs)
export const currencies = [
  { code: "XAF", name: "Franc CFA (Afrique Centrale)" },
  { code: "USD", name: "Dollar Américain" },
  { code: "EUR", name: "Euro" },
];

export const cashRegisters = [
  { id: "caisse_principale", name: "Caisse Principale" },
  { id: "caisse_departement", name: "Caisse Départementale" },
  { id: "caisse_comptoir", name: "Caisse Comptoir" },
];

//
// Fonction utilitaire pour obtenir les dénominations
//Le paramètre currencyCode est maintenant typé comme CurrencyCode
export const getDenominations = (
  currencyCode: CurrencyCode,
  cashRegisterId: string | null = null,
): Denomination[] => {
  // TypeScript sait maintenant que currencyCode est une clé valide pour allDenominations
  return allDenominations[currencyCode] || [];
};

// export const getDenominations = (currencyCode: CurrencyCode, cashRegisterId: string | null = null): CoupureDevise3[] => {
//   // TypeScript sait maintenant que currencyCode est une clé valide pour allDenominations
//   return allDenominations[currencyCode] || [];
// };

// Fonction d'aide pour formater les montants (ex: en XAF)
export const formatCurrency = (amount: number, currencyCode: string) => {
  return new Intl.NumberFormat("fr-CM", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Fonction d'aide pour formater les montants (ex: en XAF)
export const formatMillier = (amount: number) => {
  return new Intl.NumberFormat("fr-CM", {
    //style: 'currency',
    //currency: currencyCode,
    // minimumFractionDigits: 2,
    // maximumFractionDigits: 2,
  }).format(amount);
};
/**
 * Convertit un nombre (0-999) en lettres.
 * @param {number} nombre
 * @returns {string} Le nombre en lettres.
 */
export function convertirCentaines(nombre: number): string {
  if (nombre === 0) return "";
  const unites = [
    "",
    "un",
    "deux",
    "trois",
    "quatre",
    "cinq",
    "six",
    "sept",
    "huit",
    "neuf",
  ];
  const dizainesSpeciales = [
    "dix",
    "onze",
    "douze",
    "treize",
    "quatorze",
    "quinze",
    "seize",
  ];
  const dizaines = [
    "",
    "dix",
    "vingt",
    "trente",
    "quarante",
    "cinquante",
    "soixante",
    "soixante-dix",
    "quatre-vingt",
    "quatre-vingt-dix",
  ];

  let resultat = "";

  // Centaines
  if (nombre >= 100) {
    const centaine = Math.floor(nombre / 100);
    if (centaine > 1) {
      resultat += unites[centaine];
    }
    resultat += " cent";
    if (nombre % 100 === 0 && centaine > 1) {
      // "deux cents" mais "cent vingt"
      resultat += "s";
    }
    if (nombre % 100 !== 0) {
      resultat += " ";
    }
    nombre %= 100;
  }

  // Dizaines et unités
  if (nombre > 0) {
    if (nombre < 10) {
      resultat += unites[nombre];
    } else if (nombre < 17) {
      resultat += dizainesSpeciales[nombre - 10];
    } else {
      const dizaine = Math.floor(nombre / 10);
      const unite = nombre % 10;

      resultat += dizaines[dizaine];

      if (dizaine === 7 || dizaine === 9) {
        // Soixante-dix, Quatre-vingt-dix
        resultat += "-";
        if (unite === 1) resultat += "et-"; // Soixante-et-un, soixante-et-onze
        resultat += dizainesSpeciales[unite]; // Traite 10-16 pour "soixante-et-onze" etc.
      } else if (dizaine === 8 && unite === 0) {
        // Quatre-vingts
        // Pas de tiret ou de "et", le 's' a été géré par la centaine si présente
      } else {
        if (unite === 1 && dizaine !== 8) {
          // Vingt et un, Trente et un
          resultat += " et-";
        } else if (unite !== 0) {
          // Vingt-deux, Trente-trois
          resultat += "-";
        }
        resultat += unites[unite];
      }
    }
  }
  return resultat.trim();
}

/**
 * Convertit un montant numérique en sa représentation en lettres en français.
 * Gère les parties entières et décimales (centimes/francs).
 * @param {number} montant Le montant à convertir.
 * @param {string} [devisePrincipale="euro"] Le nom de l'unité monétaire principale (ex: "euro", "franc CFA").
 * @param {string} [deviseSeconde="centime"] Le nom de l'unité monétaire secondaire (ex: "centime", "franc").
 * @returns {string} Le montant en lettres.
 */
export function convertirMontantEnLettres(
  montant: number,
  devisePrincipale: string = "euro",
  deviseSeconde: string = "centime",
): string {
  if (typeof montant !== "number" || isNaN(montant)) {
    return "Montant invalide";
  }

  if (montant < 0) {
    return (
      "moins " +
      convertirMontantEnLettres(
        Math.abs(montant),
        devisePrincipale,
        deviseSeconde,
      )
    );
  }
  if (montant === 0) {
    return `zéro ${devisePrincipale}${devisePrincipale !== "euro" ? "s" : ""}`; // 'zéro euros' vs 'zéro dollars'
  }

  // Assurez-vous d'avoir au maximum 2 décimales pour les centimes/francs
  const partieEntiere = Math.floor(montant);
  let partieDecimale = Math.round((montant - partieEntiere) * 100);

  let resultat = "";

  // Traitement de la partie entière (milliards, millions, milliers, unités)
  if (partieEntiere >= 1000000000) {
    resultat +=
      convertirCentaines(Math.floor(partieEntiere / 1000000000)) + " milliard";
    if (Math.floor(partieEntiere / 1000000000) > 1) resultat += "s";
    resultat += " ";
    montant = partieEntiere % 1000000000;
  } else {
    montant = partieEntiere; // Utilise la partie entière pour le reste du traitement
  }

  if (montant >= 1000000) {
    resultat += convertirCentaines(Math.floor(montant / 1000000)) + " million";
    if (Math.floor(montant / 1000000) > 1) resultat += "s";
    resultat += " ";
    montant %= 1000000;
  }

  if (montant >= 1000) {
    const milliers = Math.floor(montant / 1000);
    if (milliers === 1) {
      // "mille" pas "un mille"
      resultat += "mille";
    } else {
      resultat += convertirCentaines(milliers) + " mille";
    }
    resultat += " ";
    montant %= 1000;
  }

  if (montant > 0) {
    resultat += convertirCentaines(montant);
  }

  // Ajout de la devise principale
  if (resultat.length > 0) {
    resultat += " ";
  }

  // Gestion du pluriel pour la devise principale
  // Attention: "un euro" (singulier) vs "zéro euro" (singulier) mais "deux euros" (pluriel)
  if (partieEntiere === 0 && partieDecimale > 0 && resultat === "") {
    // Si seulement des décimales, pas de devise principale pour l'instant
  } else {
    resultat += devisePrincipale;
    if (partieEntiere > 1 && devisePrincipale.toLowerCase() !== "euro") {
      // Règles spécifiques pour "euros" vs "dollars"
      resultat += "s";
    } else if (
      partieEntiere > 1 &&
      devisePrincipale.toLowerCase() === "euro" &&
      !resultat.includes("un euro")
    ) {
      // "deux euros"
      resultat += "s";
    }
    // Exception pour "quatre-vingts" ou "cents"
    if (
      resultat.includes("quatre-vingt") &&
      partieEntiere % 100 === 80 &&
      partieDecimale === 0
    ) {
      resultat = resultat.replace("quatre-vingt", "quatre-vingts");
    } else if (
      resultat.includes("cent") &&
      partieEntiere % 100 === 0 &&
      partieEntiere > 100 &&
      partieDecimale === 0
    ) {
      // Already handled by convertirCentaines
    }
  }

  // Traitement de la partie décimale
  if (partieDecimale > 0) {
    if (resultat.length > 0) {
      resultat += " et ";
    }
    resultat += convertirCentaines(partieDecimale) + " ";
    resultat += deviseSeconde;
    if (partieDecimale > 1) {
      resultat += "s";
    }
  } else if (resultat.trim() === "" && montant === 0) {
    // Cas spécifique pour "zéro euro" quand le montant est 0
    resultat = `zéro ${devisePrincipale}`;
    if (devisePrincipale.toLowerCase() !== "euro") {
      // 'zéro dollars'
      resultat += "s";
    }
  }

  // Ajustement final pour "un euro" / "un dollar" vs "un million"
  let finalString = resultat.trim().replace(/\s+/g, " "); // Nettoie les espaces multiples

  // Correction de l'espace après les tirets pour une meilleure lisibilité
  finalString = finalString.replace(/- /g, "-");

  return finalString;
}

export function ArrondirAmount(valeur: number): number {
  const partieEntiere = Math.floor(valeur);
  let partieDecimale = Math.round((valeur - partieEntiere) * 100);

  //int partieEntiere = (int)valeur;
  //double decimalPart = valeur - partieEntiere;

  if (partieDecimale >= 0.5) {
    return partieEntiere + 1;
  } else {
    return partieEntiere;
  }
}

export const PrintRecuCaisseDirect = async (
  CodAgce: string,
  Libelle: string,
  NomUser: string,
  Nodece: string,
  NumSeq: string,
  UtiSai: string,
  SensOpe: string,
  Devise: string,
  LibDevise: string,
  LibInfos: string,
  NumCpt: string,
  montantOpe: number,
  format: string = "pdf",
) => {
  try {
    if (LibInfos == "950" || LibInfos == "050") {
      SensOpe = "VERSEMENT ESPECES";
      LibInfos =
        "Nous portons au crédit du compte: " +
        NumCpt +
        " la somme de :" +
        formatCurrency(montantOpe, Devise) +
        " " +
        LibDevise;
    }
    if (LibInfos == "951" || LibInfos == "051") {
      SensOpe = "RETRAIT ESPECES";
      LibInfos =
        "Nous portons au débit du compte: " +
        NumCpt +
        " la somme de :" +
        formatCurrency(montantOpe, Devise) +
        " " +
        LibDevise;
    }
    if (LibInfos == "955") {
      SensOpe = "ENVOI D'ARGENT ESPECES";
      LibInfos =
        "Nous portons au crédit du compte: " +
        NumCpt +
        " la somme de :" +
        formatCurrency(montantOpe, Devise) +
        " " +
        LibDevise;
    }

    if (LibInfos == "907") {
      SensOpe = "EMISSION FONDS ESPECES";
      LibInfos =
        "Nous portons au débit du compte: " +
        NumCpt +
        " la somme de :" +
        formatCurrency(montantOpe, Devise) +
        " " +
        LibDevise;
    }
    if (LibInfos == "908") {
      SensOpe = "RECECPTION FONDS ESPECES";
      LibInfos =
        "Nous portons au crédit du compte: " +
        NumCpt +
        " la somme de :" +
        formatCurrency(montantOpe, Devise) +
        " " +
        LibDevise;
    }

    const response = await axios.get(
      `${apiEndpoints.fastReport}/PrintRecuCaisse`,
      {
        params: {
          CodAgce,
          Libelle,
          Nodece,
          NumSeq,
          UtiSai,
          NomUser,
          SensOpe,
          LibDevise,
          LibInfos,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Reçu généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

export const PrintEtatCaisseDirect = async (
  Aegece: string,
  Libelle: string,
  NomUser: string,
  Nodece: string,
  UtiSai: string,
  format: string = "pdf",
) => {
  try {
    const response = await axios.get(
      `${apiEndpoints.fastReport}/PrintEtatCaisse`,
      {
        params: {
          Nodece,
          Aegece,
          UtiSai,
          Libelle,
          NomUser,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintEtatCaisse_${Nodece}_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Etat de caisse généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

export const PrintHistCompteDirect = async (
  codUser: string,
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  NumCpt: string,
  dateDebut: Date,
  dateFin: Date,
  Type: string,
  format: string = "pdf",
) => {
  try {
    // alert(CodAgce2+' '+Libelle+' '+Banque+' '+Teleph+''+NumReg+''+Licence+''+NumCon+''+BPoste+''+Ville+''+NomUser+''+NumCpt+''+dateDebut+''+dateFin+''+Type+''+format)
    const response = await axios.get(
      `${apiEndpoints.fastReport}/transaction-histocompte`,
      {
        params: {
          CodAgce2,
          Libelle,
          Banque,
          Teleph,
          NumReg,
          Licence,
          NumCon,
          BPoste,
          Ville,
          NomUser,
          NumCpt,
          dateDebut,
          dateFin,
          Type,
          format,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintHistCompte_${NumCpt}_${codUser}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Historique généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};



export const PrintEcritureByRefDirect = async (
  codUser: string,
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  NumRefD: string,
  NumRefF: string,
  Type: string,
  format: string = "pdf",
) => {
  // public IActionResult GetReportPdfTransactionByRef([FromQuery] string CodAgce2, string Libelle, string Banque, string Teleph, string NumReg, string Licence, string NumCon, string BPoste, string Ville, string NomUser, string NumRefD, string NumRefF, string Type, string format = "PDF")

  try {
    // alert(NumRefD+' '+NumRefF)

    const response = await axios.get(
      `${apiEndpoints.fastReport}/transaction-byref`,
      {
        params: {
          CodAgce2,
          Libelle,
          Banque,
          Teleph,
          NumReg,
          Licence,
          NumCon,
          BPoste,
          Ville,
          NomUser,
          NumRefD,
          NumRefF,
          Type,
          format,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintReference_${NumRefD}_${NumRefF}_${codUser}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Lot d'écriture généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};
export const PrintEcritureByLineDirect = async (
  codUser: string,
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  NumRef: string,
  Line: number,
  Type: string,
  format: string = "pdf",
) => {
  // public IActionResult GetReportPdfTransactionByRef([FromQuery] string CodAgce2, string Libelle, string Banque, string Teleph, string NumReg, string Licence, string NumCon, string BPoste, string Ville, string NomUser, string NumRefD, string NumRefF, string Type, string format = "PDF")

  try {
    const response = await axios.get(
      `${apiEndpoints.fastReport}/transaction-byline`,
      {
        params: {
          CodAgce2,
          Libelle,
          Banque,
          Teleph,
          NumReg,
          Licence,
          NumCon,
          BPoste,
          Ville,
          NomUser,
          NumRef,
          Line,
          Type,
          format,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintReference_${NumRef}_${Line}_${codUser}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Avis d'opération généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

export const PrintTransactionCaisseDirect = async (
  codUser: string,
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  ListAgce: string,
  ListGroup: string,
  DateDebut: string,
  DateFin: string,
  Min: number,
  Max: number,
  Type: string,
  format: string = "pdf",
) => {
  //alert(DateDebut+' '+DateFin)
  try {
    if (Type == "1") {
      Type = "Listingcaissec";
    } else if (Type == "2") {
      Type = "Listingcaissed";
    } else {
      Type = "Listingcaissea";
    }

    const response = await axios.get(
      `${apiEndpoints.fastReport}/transaction-caisse`,
      {
        params: {
          CodAgce2,
          Libelle,
          Banque,
          Teleph,
          NumReg,
          Licence,
          NumCon,
          BPoste,
          Ville,
          NomUser,
          ListAgce,
          ListGroup,
          DateDebut,
          DateFin,
          Min,
          Max,
          Type,
          format,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintTransactionCaisse_${ListAgce}_${ListGroup}_${codUser}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Avis d'opération généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

export const PrintTransactionListingCaisseDirect = async (
  codUser: string,
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  ListAgce: string,
  ListGroup: string,
  DateDebut: string,
  DateFin: string,
  Min: number,
  Max: number,
  Type: string,
  format: string = "pdf",
) => {
  //alert(DateDebut+' '+DateFin)
  try {
    if (Type == "1") {
      Type = "LITIGECAISSEC";
    } else if (Type == "2") {
      Type = "LITIGECAISSED";
    } else {
      Type = "LITIGECAISSEA";
    }

    const response = await axios.get(
      `${apiEndpoints.fastReport}/transaction-caisse`,
      {
        params: {
          CodAgce2,
          Libelle,
          Banque,
          Teleph,
          NumReg,
          Licence,
          NumCon,
          BPoste,
          Ville,
          NomUser,
          ListAgce,
          ListGroup,
          DateDebut,
          DateFin,
          Min,
          Max,
          Type,
          format,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintTransactionCaisse_${ListAgce}_${ListGroup}_${codUser}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Avis d'opération généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

export const PrintTransactionBackOfficeDirect = async (
  codUser: string,
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  ListAgce: string,
  ListGroup: string,
  DateDebut: string,
  DateFin: string,
  Min: number,
  Max: number,
  Type: string,
  format: string = "pdf",
) => {
  //alert(Type)
  //let searchUser : { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }
  //let searchUser: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }
  //const [dataType, setDataType] = useState<any[]>([]);
  try {
    let TypeGroup = ListGroup;

    const response1 = await axios.get(
      `${apiEndpoints.fastReport}/client-typegroupeclient`,
      {
        params: { TypeGroup },
      },
    );

    type ClientGroup = { Code: string };
    ListGroup = (response1.data as ClientGroup[])
      .map((item: ClientGroup) => item.Code) // extrait les valeurs
      .join(","); // les met ensemble

    //  console.log(ListGroup);
    if (Type == "0") {
      Type = "Listingbackoffice0a";
    }
    if (Type == "1") {
      Type = "Listingbackoffice1a";
    }
    if (Type == "2") {
      Type = "Listingbackoffice2a";
    }
    if (Type == "3") {
      Type = "Listingbackoffice3a";
    }
    if (Type == "4") {
      Type = "Listingbackoffice4a";
    }

    const response = await axios.get(
      `${apiEndpoints.fastReport}/transaction-backoffice`,
      {
        params: {
          CodAgce2,
          Libelle,
          Banque,
          Teleph,
          NumReg,
          Licence,
          NumCon,
          BPoste,
          Ville,
          NomUser,
          ListAgce,
          ListGroup,
          DateDebut,
          DateFin,
          Min,
          Max,
          Type,
          format,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintTransactionBackOffice_${ListAgce}_${codUser}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Opérations back office générées",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

export const PrintClotureSystemeCaisseDirect = async (
  Aegece: string,
  Libelle: string,
  NomUser: string,
  Nodece: string,
  UtiSai: string,
  format: string = "pdf",
) => {
  try {
    const response = await axios.get(
      `${apiEndpoints.fastReport}/PrintClotureSystemeCaisse`,
      {
        params: {
          Nodece,
          Aegece,
          UtiSai,
          Libelle,
          NomUser,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintClutureSystemeCaisse_${Aegece}_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Etat cloture système de caisse généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

export const PrintCalculEOMDirect = async (
  Banque: string,
  Ville: string,
  BPoste: string,
  Teleph: string,
  Aegece: string,
  Libelle: string,
  NomUser: string,
  UtiSai: string,
  Choix: string,
  format: string = "pdf",
) => {
  try {
    const response = await axios.get(
      `${apiEndpoints.fastReport}/PrintCalculEOM`,
      {
        params: {
          Banque,
          Ville,
          BPoste,
          Teleph,
          Aegece,
          UtiSai,
          Libelle,
          NomUser,
          Choix,
        },
        responseType: "blob",
      },
    );

    if (response.data) {
      // alert( response.data);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
      const fileName = `PrintCalculEOM_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Etat calcul EOM généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(url, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via iframe
          const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage après quelques secondes
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: String("Erreur lors du téléchargement du fichier :"),
        icon: "error",
      });
    }

    // setLoading(false);
  } catch (error) {
    // setLoading(false);
    console.error("Erreur lors du téléchargement du fichier :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};

// ✅ Fonction d’export Excel
export const GlobalExportToExcel = (
  dataTable: any[],
  titre: string,
  fileName: string,
) => {
  if (!dataTable || dataTable.length === 0) {
    alert("Aucune donnée à exporter !");
    return;
  }

  // 1️⃣ Récupérer les en-têtes du tableau
  const headers = Object.keys(dataTable[0]);

  // 2️⃣ Construire les données Excel avec le titre en première ligne
  const wsData = [
    [titre], // Ligne 1 : titre
    headers, // Ligne 2 : entêtes
    ...dataTable.map((obj) => headers.map((h) => obj[h])), // Lignes suivantes : données
  ];

  // 3️⃣ Générer la feuille Excel
  const worksheet = XLSX.utils.aoa_to_sheet(wsData);

  // 4️⃣ Fusionner la première ligne pour que le titre occupe toute la largeur
  worksheet["!merges"] = [
    {
      s: { r: 0, c: 0 }, // start row 0, col 0
      e: { r: 0, c: headers.length - 1 }, // end row 0, last column
    },
  ];

  // 3️⃣ Style du titre
  worksheet["A1"].s = {
    font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "107C41" } },
    alignment: { horizontal: "center" },
  };

  // 4️⃣ Style des entêtes (ligne 2)
  headers.forEach((h, index) => {
    const cellRef = XLSX.utils.encode_cell({ r: 1, c: index });

    worksheet[cellRef].s = {
      font: { bold: true, color: { rgb: "FFFFFF" } }, // texte blanc
      fill: { fgColor: { rgb: "107C41" } }, // fond vert
      alignment: { horizontal: "center" }, // centrer le texte
    };
  });

  // 1️⃣ Transformer les objets JSON en feuille Excel
  // const worksheet = XLSX.utils.json_to_sheet(dataTable);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
  // 6️⃣ Export
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true, // ⚠️ indispensable pour appliquer les couleurs
  });

  // 2️⃣ Convertir en fichier et télécharger
  // const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`);
};

// ✅ Export PDF
export const GlobalExportToPDF = (
  dataTable: any[],
  titre: string,
  fileName: string,
) => {
  if (!dataTable || dataTable.length === 0) {
    alert("Aucune donnée à exporter !");
    return;
  }
  // const doc = new jsPDF();
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const columns = Object.keys(dataTable[0] || {});
  const rows = dataTable.map((row) => Object.values(row));

  doc.text(titre, 14, 15);
  // Tableau
  autoTable(doc, {
    head: [columns],
    body: rows,
    // startY: 20,
    startY: 60,
    styles: { fontSize: 7 }, // taille police
    headStyles: { fillColor: [16, 124, 65], textColor: 255 }, // couleur header
    theme: "grid",
  });

  doc.save(`${fileName}_${new Date().toISOString().split("T")[0]}.pdf`);
  //handleCloseExport();
};

// ✅ Export CSV
export const GlobalExportToCSV = (
  dataTable: any[],
  titre: string,
  fileName: string,
) => {
  if (!dataTable || dataTable.length === 0) {
    alert("Aucune donnée à exporter !");
    return;
  }
  const csvContent = [
    Object.keys(dataTable[0]).join(","), // En-têtes
    ...dataTable.map((row) => Object.values(row).join(",")), // Lignes
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}_${new Date().toISOString().split("T")[0]}.csv`;
  link.click();
  // handleCloseExport();
};
// ✅ Export JSON
export const GlobalExportToJSON = (
  dataTable: any[],
  titre: string,
  fileName: string,
) => {
  if (!dataTable || dataTable.length === 0) {
    alert("Aucune donnée à exporter !");
    return;
  }
  const blob = new Blob([JSON.stringify(dataTable, null, 2)], {
    type: "application/json",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}_${new Date().toISOString().split("T")[0]}.json`;
  link.click();
  // handleCloseExport();
};
// ✅ Export Word (DOCX)
export const GlobalExportToWord = (
  dataTable: any[],
  titre: string,
  fileName: string,
) => {
  if (!dataTable || dataTable.length === 0) {
    alert("Aucune donnée à exporter !");
    return;
  }

  const columns = Object.keys(dataTable[0]);
  const rows = dataTable.map((row) => Object.values(row));

  // 1️⃣ Titre stylé
  const titleParagraph = new Paragraph({
    children: [
      new TextRun({
        text: titre,
        bold: true,
        size: 32, // 16pt
      }),
    ],
  });

  // 2️⃣ Header du tableau
  const headerRow = new TableRow({
    children: columns.map(
      (col) =>
        new TableCell({
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: col,
                  bold: true,
                  color: "FFFFFF",
                }),
              ],
            }),
          ],
          shading: {
            color: "107C41",
            fill: "107C41",
            type: "clear",
          },
        }),
    ),
  });

  // 3️⃣ Lignes du tableau
  const bodyRows = rows.map(
    (row) =>
      new TableRow({
        children: row.map(
          (value) =>
            new TableCell({
              children: [new Paragraph(String(value))],
            }),
        ),
      }),
  );

  // 4️⃣ Construction du tableau Word
  const table = new Table({
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [headerRow, ...bodyRows],
  });

  // 5️⃣ Document Word complet en paysage
  const doc = new Document({
    sections: [
      {
        properties: {
          page: {
            size: {
              orientation: "landscape", // 🔹 orientation paysage
            },
          },
        },
        children: [titleParagraph, new Paragraph(" "), table],
      },
    ],
  });

  // 6️⃣ Téléchargement
  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, `${fileName}_${new Date().toISOString().split("T")[0]}.docx`);
  });
};

export function buildMenuTree(menus: any[]) {
  const map: any = {};
  const roots: any[] = [];

  menus.forEach((m) => {
    map[m.CODMEN] = {
      key: m.CODMEN,
      title: m.LIBELMENFR,
      parent: m.LEPERE,
      children: [],
    };
  });

  menus.forEach((m) => {
    if (m.LEPERE && map[m.LEPERE]) {
      map[m.LEPERE].children.push(map[m.CODMEN]);
    } else {
      roots.push(map[m.CODMEN]);
    }
  });

  return roots;
}
